var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1677_2569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 7.08203H11.6667",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.58203H8.75",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 4.58203H9.58333",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.082H7.08333",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.582H7.08333",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.74935 19.5846H1.24935C1.02834 19.5846 0.816374 19.4968 0.660093 19.3406C0.503813 19.1843 0.416016 18.9723 0.416016 18.7513V1.2513C0.416016 1.03029 0.503813 0.818327 0.660093 0.662046C0.816374 0.505766 1.02834 0.417969 1.24935 0.417969H12.3268C12.5478 0.418016 12.7598 0.505844 12.916 0.662135L16.0052 3.7513C16.1615 3.90755 16.2493 4.11947 16.2493 4.34047V7.08464",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.58398 14.582C9.58398 15.9081 10.1108 17.1799 11.0485 18.1176C11.9861 19.0552 13.2579 19.582 14.584 19.582C15.9101 19.582 17.1818 19.0552 18.1195 18.1176C19.0572 17.1799 19.584 15.9081 19.584 14.582C19.584 13.2559 19.0572 11.9842 18.1195 11.0465C17.1818 10.1088 15.9101 9.58203 14.584 9.58203C13.2579 9.58203 11.9861 10.1088 11.0485 11.0465C10.1108 11.9842 9.58398 13.2559 9.58398 14.582Z",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.584 12.082V17.082",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.584 17.082L12.709 15.207",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.584 17.082L16.459 15.207",
    stroke: "#58486C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1677_2569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentDownload);
export default __webpack_public_path__ + "static/media/document-download.5940e2092e2f5283fca4649c20052e93.svg";
export { ForwardRef as ReactComponent };